/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import { cloneDeep as _cloneDeep } from 'lodash';

import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import AddIcon from '@mui/icons-material/Add';

import Auth from '../../../../data/auth-service';
import FilterService from '../../../../data/filter-service';
import SystemService from '../../../../data/system-service';
import DataContext from '../../../../data/data-context';

import ConfirmationDialog from '../../../../components/confirmationdlg';

import RuleData from './ruledata';

const useStyles = makeStyles((theme) => ({
    addButton: {
        float: 'right',
    },
    heading: {
        marginRight: theme.spacing(1),
    },
}));

const RuleHandler = ({ data, filterId, type, onChange, totalRuleSize }) => {
    const classes = useStyles();
    const [ruleType, setRuleType] = useState();
    const [loading, setLoading] = useState(false);
    const [toasttype, setToastType] = useState('');
    const { systemSettings } = useContext(DataContext);
    const [filterService, setFilterService] = useState();
    const [deleteFilterRuleDialog, setDeleteFilterRuleDialog] = useState(false);
    const [index, setIndex] = useState();
    const [trafficRules, setTrafficRules] = useState([]);
    const [ruleNumber, setRuleNumber] = useState()
    const [ruleSize, setRuleSize] = useState(0);
    const [ruleEnable, setRuleEnable] = useState(true);
    const awsPerms = Auth.permissions.get('AWS');
    const [readonly] = useState(!awsPerms.write);

    useEffect(() => {
        setTrafficRules(_cloneDeep(data));
        if (type && type === 'Inbound') {
            setRuleType('Ingress');
            setToastType(type);
        }
        if (type && type === 'Outbound') {
            setRuleType('Egress');
            setToastType(type);
        }
        setRuleSize(totalRuleSize);
    }, [data, type]);

    useEffect(() => {
        if (systemSettings && systemSettings.aws) {
            if (!readonly) {
                SystemService.awsCredAccess().then((res) => {
                    if (res) {
                        const region = systemSettings.aws.as_conf.region;
                        const accessKeyId = systemSettings.aws.user_creds.access_key_id;
                        const secretAccessKey = res.AWSSK;
                        initializeService(region, accessKeyId, secretAccessKey);
                    }
                });
            }
        }
    }, [systemSettings]);

    const initializeService = async (awsregion, accessKeyId, secretAccessKey) => {
        const config = {
            region: awsregion,
            credentials: {
                accessKeyId,
                secretAccessKey,
            },
        };
        const filterservice = new FilterService(config);
        setFilterService(filterservice);
    };

    const handleAddRule = () => {
        if (ruleSize < 10) {
            const lastRule = trafficRules[trafficRules.length - 1];
            const newRuleNumber = lastRule
                ? parseInt(lastRule.RuleNumber) + 100
                : 100;

            const newRule = {
                TrafficMirrorFilterRuleId: '',
                TrafficMirrorFilterId: filterId,
                TrafficDirection: ruleType,
                RuleNumber: newRuleNumber,
                RuleAction: 'accept',
                Protocol: -1,
                DestinationPortRange: {
                    FromPort: 0,
                    ToPort: 0,
                },
                SourcePortRange: {
                    FromPort: 0,
                    ToPort: 0,
                },
                DestinationCidrBlock: '',
                SourceCidrBlock: '',
                Description: '',
            };

            setTrafficRules([...trafficRules, newRule]);
            setRuleSize(prevSize => prevSize + 1);
        } else {
            toast.error(' Filter exceeded the rule limit');
        }
    };

    const handleCreateorModifyRule = async (rule, isUpdate, index) => {
        if (filterService) {
            if (isUpdate) {
                try {
                    const res = await filterService.modifyFilterRule(rule);
                    if (res.$metadata.httpStatusCode === 200) {
                        SystemService.addAuditRecord({ "source": "AWS config", "subject": rule.TrafficMirrorFilterRuleId, "action": "update " + toasttype + " rule", "result": true });
                        toast.success(`${toasttype} rule updated successfully`);
                        const updatedRules = [...trafficRules];
                        updatedRules[index] = rule;
                        setTrafficRules(_cloneDeep(updatedRules));
                        onChange(updatedRules);
                    } else {
                        throw new Error(res);
                    }
                } catch (error) {
                    console.error('Error:', error);
                    SystemService.addAuditRecord({ "source": "AWS config", "subject": rule.TrafficMirrorFilterRuleId, "action":"Error: " + error, "result": false });
                    toast.error(`Failed to update FilterRule. \n ${error}`);
                }
            } else {
                try {
                    const res = await filterService.createFilterRule(rule);
                    if (res.$metadata.httpStatusCode === 200) {
                        rule = res.TrafficMirrorFilterRule;
                        const updatedRules = [...trafficRules];
                        updatedRules[index] = rule;
                        setTrafficRules(_cloneDeep(updatedRules));
                        onChange(updatedRules);
                        SystemService.addAuditRecord({ "source": "AWS config", "subject": rule.TrafficMirrorFilterRuleId, "action": "create " + toasttype + " rule", "result": true });
                        toast.success(`${toasttype} rule created successfully`);
                    } else {
                        throw new Error(res);
                    }
                } catch (error) {
                    console.error('Error:', error);
                    SystemService.addAuditRecord({ "source": "AWS config", "subject": "AWS Mirror Filter Rule", "action": "Error: " + error, "result": false });
                    toast.error(`Failed to add FilterRule. Please try again. \n${error}`);
                }
            }
        } else {
            toast.error('Filter service is not properly initialized method is not available');
        }
    };

    useEffect(() => {
        if (filterService) {
            setRuleEnable(false);
        }
    }, [filterService]);

    const handleDeleteRule = (index, ruleNumber) => {
        setIndex(index);
        setRuleNumber(ruleNumber);
        handleOpenDeleteFilterRuleDialog();
    };

    const deleteRule = async () => {
        setLoading(true);
        const updatedRules = [...trafficRules];
        const rule = updatedRules[index];
        if (rule.TrafficMirrorFilterRuleId.length === 0) {
            updatedRules.splice(index, 1);
            setTrafficRules(_cloneDeep(updatedRules));
            onChange(updatedRules);
            handleCloseDeleteFilterRuleDialog();
            setLoading(false);
        } else {
            try {
                const res = await filterService.deleteFilterRule(rule.TrafficMirrorFilterRuleId);
                if (res.$metadata.httpStatusCode === 200) {
                    SystemService.addAuditRecord({ "source": "AWS config", "subject": rule.TrafficMirrorFilterRuleId, "action": "remove " + toasttype + " rule", "result": true });
                    toast.success(`${toasttype} rule deleted successfully`);
                    updatedRules.splice(index, 1);
                    setTrafficRules(_cloneDeep(updatedRules));
                    onChange(updatedRules);
                    handleCloseDeleteFilterRuleDialog();
                    setLoading(false);
                } else {
                    throw new Error(res);
                }
            } catch (error) {
                console.error('Error:', error);
                SystemService.addAuditRecord({ "source": "AWS config", "subject": rule.TrafficMirrorFilterRuleId, "action":"Error: " + error, "result": false });
                toast.error(`Failed to delete FilterRule.\n${error}`);
            }
        }
    };

    const handleOpenDeleteFilterRuleDialog = () => {
        setDeleteFilterRuleDialog(true);
    };

    const handleCloseDeleteFilterRuleDialog = () => {
        setDeleteFilterRuleDialog(false);
    };

    return (
        <Box mt={2}>
            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                marginBottom={2}
            >
                <Typography variant="h6" className={classes.heading}>
                    {type === 'Inbound'
                        ? 'Inbound Traffic Mirror Rules'
                        : 'Outbound Traffic Mirror Rules'}
                </Typography>
                {!readonly && <Button
                    className={classes.addButton}
                    variant="contained"
                    color="primary"
                    aria-label="add rule"
                    disabled={ruleEnable}
                    onClick={handleAddRule}
                >
                    <AddIcon /> Rule
                </Button>}
            </Grid>

            <Grid container justifyContent="space-between">
                <Grid item xs={1}>
                    Rule Number
                </Grid>
                <Grid item xs={1}>
                    Rule Action
                </Grid>
                <Grid item xs={1}>
                    Protocol
                </Grid>
                <Grid item xs={1}>
                    Source Port
                </Grid>
                <Grid item xs={1}>
                    Destination Port
                </Grid>
                <Grid item xs={1}>
                    Source CIDR
                </Grid>
                <Grid item xs={1}>
                    Destination CIDR
                </Grid>
                <Grid item xs={2}></Grid>
            </Grid>

            {trafficRules.map((rule, index) => (
                <RuleData
                    key={index}
                    index={index}
                    rule={rule}
                    loading={loading}
                    ruleId={rule.TrafficMirrorFilterRuleId}
                    handleDelete={handleDeleteRule}
                    handleCreateOrModify={handleCreateorModifyRule}
                />
            ))}
            <ConfirmationDialog
                onClose={handleCloseDeleteFilterRuleDialog}
                onOK={deleteRule}
                open={deleteFilterRuleDialog}
                message={`Are you sure you want to remove the rule ${ruleNumber}?`}
                title="Delete Rule"
                cancelLabel="Cancel"
                okLabel="Yes"
            />
        </Box>
    );
};

export default RuleHandler;
